<mat-sidenav-container>
  @if (isAdmin() && isUserActive()) {
    <mat-nav-list>
      <a mat-list-item routerLinkActive="active" [routerLink]="['/admin/dashboard']">ADMIN DASHBOARD</a>
      <a mat-list-item routerLinkActive="active" [routerLink]="['/admin/currency-rates']">CURRENCY RATES</a>
      <a mat-list-item routerLinkActive="active" [routerLink]="['/admin/countries']">MANAGE COUNTRIES</a>
      <a mat-list-item routerLinkActive="active" [routerLink]="['/admin/regions']">MANAGE REGIONS</a>
      <a mat-list-item routerLinkActive="active" [routerLink]="['/admin/org']">ORG MANAGEMENT</a>
      <a mat-list-item routerLinkActive="active" [routerLink]="['/admin/quarters']">QUARTER MANAGEMENT</a>
      <a mat-list-item routerLinkActive="active" [routerLink]="['/admin/significant-tax']">SIGNIFICANT TAX MANAGEMENT</a>
      <a mat-list-item routerLinkActive="active" [routerLink]="['/admin/user-access']">USER ACCESS MANAGEMENT</a>
      <a mat-list-item routerLinkActive="active" [routerLink]="['/admin/ilm']">ILM MANAGEMENT</a>
      <a mat-list-item routerLinkActive="active" [routerLink]="['/admin/reports']">REPORTING</a>
      <a mat-list-item [routerLink]="['/']">ASC 450 APPLICATION</a>
    </mat-nav-list>
  }

  @if (!isAdmin() && isUserActive()) {
    <mat-nav-list>
      <a mat-list-item routerLinkActive="active" [routerLink]="['/data-entry-status']">DATA ENTRY STATUS</a>
      <a mat-list-item routerLinkActive="active" [routerLink]="['/validation-review']">VALIDATION &amp; REVIEW</a>
      <a mat-list-item routerLinkActive="active" [routerLink]="['/filing-obligation']">FILING OBLIGATION</a>
      <a mat-list-item routerLinkActive="active" [routerLink]="['/general-questionnaire']">GENERAL QUESTIONNAIRE</a>
      <a mat-list-item routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" [routerLink]="['/taxes']">TAX DASHBOARD</a>
      <a mat-list-item routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" [routerLink]="['/taxes/questionnaire']">TAX QUESTIONNAIRE</a>
      <a mat-list-item routerLinkActive="active" [routerLink]="['/loss-contingency']">LOSS CONTINGENCY DASHBOARD</a>
      <a mat-list-item routerLinkActive="active" [routerLink]="['/aged-asset']">AGED ASSET DASHBOARD</a>
      @if (user?.admin) {
        <a mat-list-item routerLinkActive="active" [routerLink]="['/admin/dashboard']">ADMIN DASHBOARD</a>
      }
    </mat-nav-list>
  }
</mat-sidenav-container>
